/* eslint-disable no-unused-expressions */
/* eslint-disable no-else-return */
/* eslint-disable no-bitwise */
/* eslint-disable vars-on-top */
/* eslint-disable radix */
/* eslint-disable no-var */
import PropTypes from 'prop-types';
import { createContext } from 'react';
// hooks
import useLocalStorage from '../hooks/useLocalStorage';
// theme
import palette from '../theme/palette';

// ----------------------------------------------------------------------

const PRIMARY_COLOR = [
  // DEFAULT
  {
    name: 'default',
    ...palette.light.primary
  },
  // GREEN
  {
    name: 'green',
    lighter: '#217f5d',
    light: '#217f5d',
    main: '#217f5d',
    dark: '#1d6148',
    darker: '#1d6148',
    contrastText: '#fff'
  },
  // PURPLE
  {
    name: 'purple',
    lighter: '#EBD6FD',
    light: '#B985F4',
    main: '#05164D',
    dark: '#431A9E',
    darker: '#200A69',
    contrastText: '#fff'
  },
  // CYAN
  {
    name: 'cyan',
    lighter: '#D1FFFC',
    light: '#76F2FF',
    main: '#1CCAFF',
    dark: '#0E77B7',
    darker: '#053D7A',
    contrastText: palette.light.grey[800]
  },
  // BLUE
  {
    name: 'blue',
    lighter: '#CCDFFF',
    light: '#6697FF',
    main: '#0045FF',
    dark: '#0027B7',
    darker: '#00137A',
    contrastText: '#fff'
  },
  // ORANGE
  {
    name: 'orange',
    lighter: '#FEF4D4',
    light: '#FED680',
    main: '#fda92d',
    dark: '#B66816',
    darker: '#793908',
    contrastText: palette.light.grey[800]
  },
  // RED
  {
    name: 'red',
    lighter: '#FFE3D5',
    light: '#FFC1AC',
    main: '#FF3030',
    dark: '#B71833',
    darker: '#7A0930',
    contrastText: '#fff'
  }
];

// function adjustColorShade(color, amount) {
//   console.log('color', color);
//   return `#
//     ${color.replace(/^#/, '').replace(
//       /../g,
//       (color) =>
//         `0${Math.min(255, Math.max(0, parseInt(color, 16) + amount))
//           .toString(16)
//           .substring(-2)}`
//     )}`;
// }

const adjustColorShade = (hexColor, magnitude) => {
  hexColor = hexColor.replace(`#`, ``);
  if (hexColor.length === 6) {
    const decimalColor = parseInt(hexColor, 16);
    let r = (decimalColor >> 16) + magnitude;
    r > 255 && (r = 255);
    r < 0 && (r = 0);
    let g = (decimalColor & 0x0000ff) + magnitude;
    g > 255 && (g = 255);
    g < 0 && (g = 0);
    let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
    b > 255 && (b = 255);
    b < 0 && (b = 0);
    return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
  } else {
    return hexColor;
  }
};
SetColor.propTypes = {
  themeColor: PropTypes.oneOf(['default', 'green', 'purple', 'cyan', 'blue', 'orange', 'red'])
};

function SetColor(themeColor) {
  let color;
  const DEFAULT = PRIMARY_COLOR[0];
  const GREEN = PRIMARY_COLOR[1];
  const PURPLE = PRIMARY_COLOR[2];
  const CYAN = PRIMARY_COLOR[3];
  const BLUE = PRIMARY_COLOR[4];
  const ORANGE = PRIMARY_COLOR[5];
  const RED = PRIMARY_COLOR[6];

  // console.log('adjusted', adjustColorShade(themeColor, -40));
  console.log('themeColor', themeColor);
  // console.log('themsdafadeColor', themeColor);

  const customColor = {
    name: 'custom',
    lighter: adjustColorShade(themeColor, -40),
    light: adjustColorShade(themeColor, -20),
    main: themeColor,
    dark: adjustColorShade(themeColor, 20),
    darker: adjustColorShade(themeColor, 40),
    contrastText: '#fff'
  };

  console.log('customColor', customColor);
  console.log('SetColor', themeColor);

  switch (themeColor) {
    case 'default':
      color = GREEN;
      break;
    case 'green':
      color = GREEN;
      break;
    case 'purple':
      color = PURPLE;
      break;
    case 'cyan':
      color = CYAN;
      break;
    case 'blue':
      color = BLUE;
      break;
    case 'orange':
      color = ORANGE;
      break;
    case 'red':
      color = RED;
      break;
    default:
      color = customColor;
  }
  return color;
}

const initialState = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeColor: 'default',
  themeStretch: false,
  onChangeMode: () => {},
  onChangeDirection: () => {},
  onChangeColor: () => {},
  // onChangeCustomColor: () => {},
  onToggleStretch: () => {},
  setColor: PRIMARY_COLOR[0],
  colorOption: []
};

const SettingsContext = createContext(initialState);

SettingsProvider.propTypes = {
  children: PropTypes.node
};

function SettingsProvider({ children }) {
  const [settings, setSettings] = useLocalStorage('settings', {
    themeMode: initialState.themeMode,
    themeDirection: initialState.themeDirection,
    themeColor: initialState.themeColor,
    themeStretch: initialState.themeStretch
  });

  const onChangeMode = (event) => {
    setSettings({
      ...settings,
      themeMode: event.target.value
    });
  };

  const onChangeDirection = (event) => {
    setSettings({
      ...settings,
      themeDirection: event.target.value
    });
  };

  const onChangeColor = (event) => {
    console.log('selected color', event.target.value);
    setSettings({
      ...settings,
      themeColor: event.target.value
    });
  };

  // const onChangeCustomColor = (event) => {
  //   console.log('selected color', event.target.value);
  //   setSettings({
  //     ...settings,
  //     themeColor: event.target.value
  //   });
  // };

  const onToggleStretch = () => {
    setSettings({
      ...settings,
      themeStretch: !settings.themeStretch
    });
  };

  return (
    <SettingsContext.Provider
      value={{
        ...settings,
        // Mode
        onChangeMode,
        // Direction
        onChangeDirection,
        // Color
        onChangeColor,
        // onChangeCustomColor,
        setColor: SetColor(settings.themeColor),
        colorOption: PRIMARY_COLOR.map((color) => ({
          name: color.name,
          value: color.main
        })),
        // Stretch
        onToggleStretch
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export { SettingsProvider, SettingsContext };
